import {Resource, Company, CompanyEmployee} from '@cquential/api';
import {ResourceWithKeyedByDateObjects} from '@/types/api-object-extensions';

export default class CellCapacity {
    public static mayContainDeployments(date: Date, resource?: Resource | ResourceWithKeyedByDateObjects | null, company?: Company | null, companyEmployee?: CompanyEmployee | null): boolean {
        if (company?.openShiftMarketplaceSyncEnabled && !companyEmployee) {
            return false;
        }

        return (resource && resource.beginDate <= date && resource.endDate >= date)
            || !!(company && (!company.endDate || company.endDate >= date));
    }
}
